// extracted by mini-css-extract-plugin
export default {"renderWrapper":"footer__renderWrapper___2jDGt","preventScroll":"footer__preventScroll___1DS7O"};